import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-down-arrow-icon',
  templateUrl: './lib-down-arrow-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibDownArrowIconComponent {}
